import { GR_CODE_CRIMINAL } from "../../../../constants";

const birthPlaceNotGreeceValidate = (value, ctx) => {
  if (value || parseInt(ctx?.parent?.birth_country?.id) == GR_CODE_CRIMINAL) {
    return true;
  } else {
    return false;
  }
};

export default birthPlaceNotGreeceValidate;
